"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    FETCH_STRATEGY_RESPONSE_SOURCE_HEADER_NAME: ()=>FETCH_STRATEGY_RESPONSE_SOURCE_HEADER_NAME,
    FetchStrategyResponseSourceHeaderValue: ()=>FetchStrategyResponseSourceHeaderValue
});
const FETCH_STRATEGY_RESPONSE_SOURCE_HEADER_NAME = 'x-bytecloud-fetch-strategy-source';
var FetchStrategyResponseSourceHeaderValue = /*#__PURE__*/ function(FetchStrategyResponseSourceHeaderValue) {
    FetchStrategyResponseSourceHeaderValue["Network"] = "network";
    FetchStrategyResponseSourceHeaderValue["Cache"] = "cache";
    return FetchStrategyResponseSourceHeaderValue;
}({});
exports.FETCH_STRATEGY_RESPONSE_SOURCE_HEADER_NAME = __webpack_exports__.FETCH_STRATEGY_RESPONSE_SOURCE_HEADER_NAME;
exports.FetchStrategyResponseSourceHeaderValue = __webpack_exports__.FetchStrategyResponseSourceHeaderValue;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "FETCH_STRATEGY_RESPONSE_SOURCE_HEADER_NAME",
    "FetchStrategyResponseSourceHeaderValue"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
